import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavbarComponent } from './navbar/navbar.component';
import { LoginRegisterModalComponent } from './login-register-modal/login-register-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BeneficiaryComponent } from './beneficiary/beneficiary.component';
import { TransactionComponent } from './transaction/transaction.component';
import {MatIconModule} from '@angular/material/icon';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { FooterComponent } from './footer/footer.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RegisterComponent } from './register/register.component';
import { BuyCoinsComponent } from './buy-coins/buy-coins.component';
import { SideNavbarComponent } from './side-navbar/side-navbar.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginRegisterModalComponent,
    HomeComponent,
    DashboardComponent,
    BeneficiaryComponent,
    TransactionComponent,
    TransactionHistoryComponent,
    FooterComponent,
    ResetPasswordComponent,
    RegisterComponent,
    BuyCoinsComponent,
    SideNavbarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    MatIconModule
  ],
  providers: [
    {
      provide:HTTP_INTERCEPTORS,
      useClass:TokenInterceptorService,
      multi:true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
